import React from "react";
import "./index.css";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import Box from "@mui/material/Box";
import { CardActionArea, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
interface AppFontProps {
  children: React.ReactNode;
}
interface CircleBtnProps {
  image: any;
  imagetwo?: any;
  text: string;
  bgColor?: string;
  alpha: boolean;
  handleBlink?: () => void;
}
interface BlubsProps {
  toggleTheBulb: boolean;
}
interface RemoteProps {
  fly: string;
  handleBlink?: () => void;
}

export const CircleButton = ({
  image,
  alpha,
  text,
  handleBlink,
}: CircleBtnProps) => {
  return (
    <div onClick={handleBlink}>
      {alpha ? (
        <div>
          <div>
            <img src={image} className="btn-image" alt="" />
          </div>
          <AppFont>{text}</AppFont>
        </div>
      ) : (
        <div>
          <div>
            <CardActionArea className="layout">
              <img
                src={image}
                className="btn-imagetwo"
                width={"30px"}
                height={"30px"}
                alt=""
                style={{ cursor: "pointer" }}
              />
            </CardActionArea>
            <AppFont>{text}</AppFont>
          </div>
        </div>
      )}
    </div>
  );
};
export const IndicateBlub = ({ toggleTheBulb }: BlubsProps) => {
  return (
    <div>
      {toggleTheBulb ? (
        <div className="blub-layout"></div>
      ) : (
        <div className="redblub-layout"></div>
      )}
    </div>
  );
};
export const AppFont = ({ children }: AppFontProps) => {
  return <div className="app-font">{children}</div>;
};

export const IncDecBtn = ({
  image,
  text,
  imagetwo,
  handleBlink,
}: CircleBtnProps) => {
  return (
    <div className="remote-inc-dec-btn">
      <Box>
        <CardActionArea onClick={handleBlink} style={{ borderRadius: "100%" }}>
          <img src={image} className="btn-image" alt="" />
        </CardActionArea>
      </Box>
      <AppFont>{text}</AppFont>
      <Box>
        <CardActionArea onClick={handleBlink} style={{ borderRadius: "100%" }}>
          <img src={imagetwo} className="btn-image" alt="" />
        </CardActionArea>
      </Box>
    </div>
  );
};

export const Remote = ({ fly, handleBlink }: RemoteProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "100%",
        border: "1px solid white",
        mb: 3,
      }}
      className={`${fly}`}
    >
      <Box>
        <CardActionArea onClick={handleBlink} style={{ borderRadius: "100%" }}>
          <ArrowDropUpIcon className="remote-image" />
        </CardActionArea>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly ",
          alignItems: "center",
        }}
      >
        <Box>
          <CardActionArea
            onClick={handleBlink}
            style={{ borderRadius: "100%" }}
          >
            <ArrowLeftIcon className="remote-image" />
          </CardActionArea>
        </Box>
        <CardActionArea onClick={handleBlink} className="inside-border">
          <AppFont>{`OK`}</AppFont>
        </CardActionArea>
        <Box>
          <CardActionArea
            onClick={handleBlink}
            style={{ borderRadius: "100%" }}
          >
            <ArrowRightIcon className="remote-image" />
          </CardActionArea>
        </Box>
      </Box>
      <Box>
        <CardActionArea onClick={handleBlink} style={{ borderRadius: "100%" }}>
          <ArrowDropDownIcon className="remote-image" />
        </CardActionArea>
      </Box>
    </Box>
  );
};

type ImageBtnProps = {
  variant: "contained" | "outlined" | "text";
  startImg: React.ReactNode | any;
  text: string;
};

export const ImageButton = ({ variant, text, startImg }: ImageBtnProps) => {
  return (
    <Button variant={variant} className="img-Btn">
      <img src={startImg} alt="" width={"30px"} height={"30px"} />
      <Box sx={{ ml: 1 }}>{text}</Box>
    </Button>
  );
};

export const TwinTextBtn = styled(CardActionArea)(({ theme }) => ({
  backgroundColor: "#3E3E3E",
  width: 137,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  height: 75,
  borderRadius: "15px",
  [theme.breakpoints.down("md")]: {
    width: 120,
    marginRight: 10,
  },
}));

export const RoundedBtn = styled(CardActionArea)(({ theme }) => ({
  width: 137,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  height: 50,
  borderRadius: "50px",
  border: "1px solid #FFFFFF",
  transition: "all 0.5s ease-in-out",
  "&:hover": {
    backgroundColor: "white",
    color: "#3E3E3E",
  },
  ":focus": {
    backgroundColor: "white",
    color: "black"
},
  [theme.breakpoints.down("md")]: {
    width: 120,
    marginRight: 10,
  },
}));
